<template>
	<div class="modal-update" data-id="update" @click.stop>
		<div class="bg"></div>
		<div class="container">
			<header class="w-full header">
				<h2 class="title">Des problèmes d'affichages?</h2>
			</header>

			<hr class="horizontal-line" />
			<p class="description">Vérifie si des mises à jour sont disponibles pour ton navigateur (Chrome, Edge, Safari ou autres) et ton système d'exploitation (Windows, macOS, Android, iOS ou autres), puis installe-les.</p>
			<div class="footer">
				<ui-button class="btn success" color="green" data-id="event-btn" v-tap="close">Ok!</ui-button>
			</div>
		</div>
	</div>
</template>

<script setup lang="js">
import {useMapStore} from "@/stores/map-store.js";
import {medias} from "@affordancestudio/engage-game";

const emits = defineEmits(['close'])
const mapStore = useMapStore()
const characterImage = ref(null)
const ticket = ref({})

onMounted(() => {
  characterImage.value = medias.findAllByTags({ tags: [ 'character', 'character-bottom-right' ] })?.[0]
  ticket.value = mapStore.categories?.data?.[0]
})

function close(){
	emits('close')
}
</script>

<style lang="stylus" scoped>
$black = #54606C

.hidden
	visibility: hidden

.header
	display flex
	justify-content center
	align-items center

.w-full
	width 100%

.container
	border-radius 16px
	padding 16px 24px
	display flex
	flex-direction column
	justify-content center
	align-items center
	width 720px
	max-width 95vw !important
	background-color #fff
	padding-block 8px
	
	.title
		color $black
		text-align center
		font-size 2.5rem
		padding-bottom 8px

	.img
		height  420px
		max-width 100%

	.description
		color $black
		font-size 2rem
		text-align center
		text-wrap balance
		margin-block 32px
	.mt-description
		margin-top 24px

.btn-description
	color $black
	margin-top 4px
	margin-inline auto
	font-size 1.2rem
	text-align center
	width 80%


.footer
	width 100%
	display flex
	flex-wrap wrap
	justify-content center
	gap 16px
	margin-top 16px
	margin-bottom 8px
	.btn
		height  fit-content
		padding-block 8px 
		width fit-content
		font-size 16px

.horizontal-line
	width 100%
	height 2px
	margin-bottom 9px
	border none
	background-color blue

.modal-update
	flex center
	> .bg
		absolute 0

.ticket {
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  position: relative !important;
  transform-origin: center !important;
  transform: rotate(-4deg) scale(0.75) !important;
}

.mt
	margin-top 48px
.mb
	margin-bottom 48px
</style>